import { useState } from 'react';
import useAutoupdatePresenterProperty from '../../hooks/useAutoupdatePresenterProperty';
import SharedViewNavPresenter from './SharedViewNavPresenter';

const useSharedViewNavPresenter = ( { assets } ) => {
	const createPresenter = () => new SharedViewNavPresenter( { assets } );

	const [ presenter ] = useState( createPresenter );

	useAutoupdatePresenterProperty( { presenter, name: 'assets', value: assets } );

	return presenter;
};

export default useSharedViewNavPresenter;
